module.exports = __webpack_public_path__ + "static/media/flooring_material_60yd_y.54e60bf1.csv";